import { useState, useEffect } from 'react';
import { useSearchFields } from '../SearchFieldProvider';
import { useLocation, useNavigate } from 'react-router-dom';

export default function SearchBarResultsPage({ show, setShow }) {
    const { keyword, location, startDate, endDate, setKeyword, setLocation, setStartDate, setEndDate } = useSearchFields();
    const [keyInput, setKeyInput] = useState(keyword);
    const [locInput, setLocInput] = useState(location);
    const [startInput, setStartInput] = useState(startDate);
    const [endInput, setEndInput] = useState(endDate);
    const [inputType, setInputType] = useState('text');
    const url = useLocation();
    const navigate = useNavigate();

    const handleFocus = () => {
        setInputType('date');
    };

    useEffect(() => {
        setKeyInput(keyword);
        setLocInput(location);
        setStartInput(startDate);
        setEndInput(endDate);
    }, [keyword, location, startDate, endDate])
    
    const onSubmit = () => {
        setKeyword(keyInput);
        setLocation(locInput);
        setStartDate(startInput);
        setEndDate(endInput);

        if (url.pathname !== '/searchResults') {
            navigate('/searchResults')
        }
        setShow(false);
    };

    document.addEventListener("keydown", e => {
        if (e.key === "Enter") {
            onSubmit();
        }
    });

    return (
            <div className={`row ${show ? "justify-content-center" : "justify-content-end"}`}>
                <div className="col-8 col-md-7 col-lg-7 search-bar-mini search-outline">
                    <div className="row justify-content-end">
                    <div className="col-10">
                        <div className="input-group input-group">
                            <input type="text" className="form-control" placeholder="Keyword" aria-label="Keyword" 
                                style={{ borderTopLeftRadius: 500, borderBottomLeftRadius: 500, color: "gray"}} value={keyInput}
                                onChange={event => setKeyInput(event.target.value)}/>
                            <input type="text" className="form-control d-none d-md-block" placeholder="Location" aria-label="Location" style={{ color: "gray" }}
                                onChange={event => setLocInput(event.target.value)} value={locInput}/>
                            <input id="startDate" className="form-control" type={inputType} style={{ fontSize: 16, color: "gray"}} placeholder="Start" onFocus={handleFocus} 
                                onChange={event => setStartInput(event.target.value)} value={startInput} aria-label="start date input"/>
                            <input id="endDate" className="form-control" type={inputType} placeholder="End" onFocus={handleFocus} 
                                onChange={event => setEndInput(event.target.value)} value={endInput}  aria-label="end date input"
                                style={{ borderTopRightRadius: 500, borderBottomRightRadius: 500, fontSize: 16, color: 'gray'}}/>
                        </div>
                        </div>
                        <div className="col-2 col-lg-auto">
                            <button className="btn btn-dark" type="submit" onClick={onSubmit}
                            style={{ borderRadius: 500 }}>
                                <i className="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div> 
    );
}
